import type { EventPayload } from './adminEventsBus';
import { currentUser } from 'js/utils/user';

export function emit(payload: EventPayload): void {
  if (process.env.NODE_ENV !== 'development' && !currentUser?.admin) return;
  void import('./adminEventsBus').then(({ emit: e }) => e(payload));
}
